import { render, staticRenderFns } from "./ShowProductListButton.vue?vue&type=template&id=9b050cea&"
import script from "./ShowProductListButton.vue?vue&type=script&lang=js&"
export * from "./ShowProductListButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports